import { render, staticRenderFns } from "./OcupacionComponent.vue?vue&type=template&id=f91a7308"
import script from "./OcupacionComponent.vue?vue&type=script&lang=js"
export * from "./OcupacionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports